<template>
  <div class="page-wrapper">
    <!-- ============== PC版 ============== -->
    <div class="pc-version">
      <div
        class="fusion-log-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- PC 搜索栏 -->
        <div
          class="search-bar"
          style="
            margin-bottom: 20px;
            display: flex;
            gap: 10px;
            align-items: center;
            flex-wrap: wrap;
          "
        >
          <div class="search-collapse-btn" @click="toggleSearch">
            <i
              class="el-icon-arrow-down"
              :class="{ 'el-icon-arrow-up': !searchCollapsed }"
            ></i>
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </div>
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              gap: '10px',
              alignItems: 'center',
            }"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              style="width: 160px"
              clearable
            ></el-input>
            <el-select v-model="searchParams.type" placeholder="选择类型" style="width:160px" clearable>
              <el-option
                v-for="item in typeOptions"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              />
            </el-select>
          </div>
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button type="primary" @click="getList">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </div>
        </div>

        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%"
          @row-click="handleRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="用户ID" prop="user_id" width="120" align="center" />
          <el-table-column label="昵称" prop="nickname" width="120" align="center" />
          <el-table-column label="物品名称" prop="goods_name" min-width="140" />

          <!-- 奖品图片 -->
          <el-table-column label="物品图片" width="100" align="center">
            <template slot-scope="scope">
              <el-image
                :src="scope.row.goods_image"
                fit="cover"
                style="width: 50px; height: 50px; border-radius: 4px; cursor: pointer"
                :preview-src-list="[scope.row.goods_image]"
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column label="等级" prop="level_name" width="100" align="center" />
          <el-table-column label="价值" prop="price" width="100" align="center" />
          <el-table-column label="回收价" prop="recovery_price" width="100" align="center" />
          <el-table-column label="数量" prop="num" width="80" align="center" />
          <el-table-column label="类型" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="getTypeTagType(scope.row.type)">
                {{ scope.row.type === 1 ? '实物' : '卡片' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="新订单ID" prop="new_order_id" width="120" align="center" />
          <el-table-column label="消耗奖品ID" prop="old_prize_ids" min-width="200" show-overflow-tooltip />
          <el-table-column label="创建时间" prop="created_at" width="180" align="center" />
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC详情弹窗 -->
        <el-dialog
          title="融合详情"
          :visible.sync="detailVisible"
          width="750px"
          append-to-body
        >
          <el-form :model="detailForm" label-width="130px" size="small">
            <el-form-item label="ID"><span>{{ detailForm.id }}</span></el-form-item>
            <el-form-item label="用户ID"><span>{{ detailForm.user_id }}</span></el-form-item>
            <el-form-item label="用户昵称"><span>{{ detailForm.nickname }}</span></el-form-item>
            <el-form-item label="物品名称"><span>{{ detailForm.goods_name }}</span></el-form-item>
            
            <!-- 详情图片 -->
            <el-form-item label="物品图片">
              <el-image
                :src="detailForm.goods_image"
                fit="cover"
                style="width: 80px; height: 80px; border-radius: 4px"
                :preview-src-list="[detailForm.goods_image]"
              ></el-image>
            </el-form-item>

            <el-form-item label="等级"><span>{{ detailForm.level_name }}</span></el-form-item>
            <el-form-item label="价值金额"><span>{{ detailForm.price }} 元</span></el-form-item>
            <el-form-item label="回收金额"><span>{{ detailForm.recovery_price }} 元</span></el-form-item>
            <el-form-item label="数量"><span>{{ detailForm.num }}</span></el-form-item>
            <el-form-item label="类型"><span>{{ detailForm.type === 1 ? '实物融合' : '卡片融合' }}</span></el-form-item>
            <el-form-item label="新订单ID"><span>{{ detailForm.new_order_id }}</span></el-form-item>
            <el-form-item label="消耗奖品ID"><span>{{ detailForm.old_prize_ids }}</span></el-form-item>
            <el-form-item label="创建时间"><span>{{ detailForm.created_at }}</span></el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ============== 移动端 ============== -->
    <div class="mobile-version">
      <div
        class="mobile-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <div class="mobile-search">
          <div class="mobile-search-collapse" @click="toggleSearch">
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </div>
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              clearable
              size="medium"
            ></el-input>
            <el-select v-model="searchParams.type" placeholder="选择类型" clearable>
              <el-option
                v-for="item in typeOptions"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              />
            </el-select>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 10px">
            <el-button
              type="primary"
              plain
              round
              style="flex: 1"
              @click="getList"
              >搜索</el-button
            >
            <el-button plain round style="flex: 1" @click="resetSearch"
              >重置</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="handleRowClickMobile(item)"
          >
            <div class="card-top">
              <div class="label">{{ item.goods_name }}</div>
              <el-tag :type="getTypeTagType(item.type)" size="mini">
                {{ item.type === 1 ? '实物' : '卡片' }}
              </el-tag>
            </div>

            <!-- 移动端卡片图片 -->
            <div style="margin: 10px 0">
              <el-image
                :src="item.goods_image"
                fit="cover"
                style="width: 70px; height: 70px; border-radius: 6px"
                :preview-src-list="[item.goods_image]"
              ></el-image>
            </div>

            <div class="card-body">
              <div><span>用户：</span>{{ item.user_id }} ({{item.nickname}})</div>
              <div><span>等级：</span>{{ item.level_name }}</div>
              <div><span>价值：</span>{{ item.price }} 元</div>
              <div><span>数量：</span>{{ item.num }}</div>
              <div><span>订单ID：</span>{{ item.new_order_id }}</div>
              <div><span>时间：</span>{{ item.created_at }}</div>
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="prev, pager, next, total"
            :total="total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端详情弹窗 -->
        <el-dialog
          title="融合详情"
          :visible.sync="detailVisibleMobile"
          width="90%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form :model="detailForm" label-width="100px" size="small">
            <el-form-item label="ID"><span>{{ detailForm.id }}</span></el-form-item>
            <el-form-item label="用户ID"><span>{{ detailForm.user_id }}</span></el-form-item>
            <el-form-item label="昵称"><span>{{ detailForm.nickname }}</span></el-form-item>
            <el-form-item label="物品名"><span>{{ detailForm.goods_name }}</span></el-form-item>
            
            <!-- 移动端详情图片 -->
            <el-form-item label="物品图片">
              <el-image
                :src="detailForm.goods_image"
                fit="cover"
                style="width: 70px; height: 70px; border-radius: 4px"
                :preview-src-list="[detailForm.goods_image]"
              ></el-image>
            </el-form-item>

            <el-form-item label="等级"><span>{{ detailForm.level_name }}</span></el-form-item>
            <el-form-item label="价值"><span>{{ detailForm.price }} 元</span></el-form-item>
            <el-form-item label="数量"><span>{{ detailForm.num }}</span></el-form-item>
            <el-form-item label="类型"><span>{{ detailForm.type === 1 ? '实物' : '卡片' }}</span></el-form-item>
            <el-form-item label="订单ID"><span>{{ detailForm.new_order_id }}</span></el-form-item>
            <el-form-item label="消耗ID"><span>{{ detailForm.old_prize_ids }}</span></el-form-item>
            <el-form-item label="时间"><span>{{ detailForm.created_at }}</span></el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisibleMobile = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";

export default {
  name: "FusionLogList",
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      typeOptions: [
        { type: 1, desc: "实物融合" },
        { type: 2, desc: "卡片融合" }
      ],
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
        type: ""
      },
      detailVisible: false,
      detailVisibleMobile: false,
      detailForm: {},
      searchCollapsed: true,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await api.users.fusionLog({
          params: this.searchParams,
        });
        if (res.data.code == "1000") {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
        }
      } finally {
        this.loading = false;
      }
    },

    // 类型标签样式
    getTypeTagType(type) {
      return type === 1 ? "primary" : "success";
    },

    // PC行点击
    handleRowClick(row) {
      this.detailForm = { ...row };
      this.detailVisible = true;
    },
    // 移动端行点击
    handleRowClickMobile(row) {
      this.detailForm = { ...row };
      this.detailVisibleMobile = true;
    },

    // 重置搜索
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
        type: ""
      };
      this.getList();
    },

    // 分页
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    // 展开/收起搜索
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
  },
};
</script>

<style scoped>
.fusion-log-container {
  padding: 20px;
}
.mobile-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.card-top .label {
  font-size: 15px;
  font-weight: 500;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
}
.card-body span {
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/pages/user/fusionLog.vue